import { Popover as PopoverPrimitive } from '@mui/material';
import classnames from 'classnames';
import { forwardRef, useImperativeHandle, useMemo, useRef, useState } from 'react';

import styles from './Popover.module.scss';
import { extractTrigger, PopoverActions, PopoverProps } from './Popover.types';

export const Popover = forwardRef<PopoverActions, PopoverProps>(
  ({ trigger, disabled, className, onOpen, onClose, slotProps, ...props }, ref) => {
    const [isOpen, setIsOpen] = useState(false);

    const menuActions = useMemo(
      (): PopoverActions => ({
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
      }),
      []
    );

    useImperativeHandle(ref, () => menuActions, [menuActions]);

    const triggerRef = useRef<HTMLSpanElement | null>(null);

    return (
      <>
        <span
          className={styles.trigger}
          data-triggered={isOpen && !disabled ? 'triggered' : ''}
          onClick={() => {
            if (disabled) return;
            setIsOpen(true);
            onOpen?.();
          }}
          ref={triggerRef}
        >
          {trigger}
        </span>
        {isOpen && !disabled && (
          <PopoverPrimitive
            anchorEl={extractTrigger(triggerRef.current)}
            open
            onClose={(event, reason) => {
              setIsOpen(false);
              onClose?.(event, reason);
            }}
            onClick={event => event.stopPropagation()}
            onMouseDown={event => event.stopPropagation()}
            onMouseUp={event => event.stopPropagation()}
            slotProps={{
              ...slotProps,
              paper: { ...slotProps?.paper, className: classnames(styles.popover, className) },
            }}
            {...props}
          />
        )}
      </>
    );
  }
);
